import { useMemo } from 'react'
import * as THREE from 'three'
import { MalhaDetalhe, unirDetalhes } from './DetalhesMecanicos3D'

/** Detalhes locais: acompanham o mesmo pivô e a mesma subpeça da porta. */
export function DetalhesPorta3D({ id, sinal, comprimento, altura, parte }: {
  id: string; sinal: number; comprimento: number; altura: number
  parte: 'forro' | 'maquinaVidro' | 'motorVidro' | 'altoFalante'
}) {
  const criar = useMemo(() => () => {
    const pecas: THREE.BufferGeometry[] = []
    const caixa = (w: number, h: number, d: number, x: number, y: number, z: number) =>
      pecas.push(new THREE.BoxGeometry(w, h, d).translate(x, y, z))
    const disco = (raio: number, espessura: number, x: number, y: number, z: number, segmentos = 16) =>
      pecas.push(new THREE.CylinderGeometry(raio, raio, espessura, segmentos).rotateZ(Math.PI / 2).translate(x, y, z))
    if (parte === 'forro') {
      // Apoio de braço, nicho inferior e grade do alto-falante no acabamento.
      caixa(0.07, 0.035, comprimento * 0.56, -sinal * 0.085, altura * 0.48, 0)
      caixa(0.03, altura * 0.18, comprimento * 0.73, -sinal * 0.075, -altura * 0.27, 0)
      for (let i = 0; i < 8; i++) caixa(0.006, 0.085, 0.005, -sinal * 0.072, -altura * 0.23, -comprimento * 0.28 + (i - 3.5) * 0.013)
    } else if (parte === 'maquinaVidro') {
      for (const y of [-altura * 0.33, altura * 0.33]) {
        disco(0.027, 0.014, -sinal * 0.034, y, 0)
        pecas.push(new THREE.TorusGeometry(0.027, 0.004, 6, 20).rotateY(Math.PI / 2).translate(-sinal * 0.045, y, 0))
      }
      for (const z of [-0.029, 0.029]) caixa(0.007, altura * 0.66, 0.004, -sinal * 0.04, 0, z)
      caixa(0.038, 0.05, 0.075, -sinal * 0.048, altura * 0.18, 0)
      for (const z of [-comprimento * 0.24, comprimento * 0.24]) {
        disco(0.014, 0.012, -sinal * 0.046, -altura * 0.36, z, 6)
      }
    } else if (parte === 'motorVidro') {
      disco(0.053, 0.016, -sinal * 0.01, 0, 0)
      caixa(0.08, 0.035, 0.035, 0, -0.045, 0.045)
      for (let i = 0; i < 4; i++) disco(0.008, 0.01, -sinal * 0.045, Math.cos(i * Math.PI / 2) * 0.034, Math.sin(i * Math.PI / 2) * 0.034, 6)
    } else {
      pecas.push(new THREE.TorusGeometry(0.066, 0.007, 6, 24).rotateY(Math.PI / 2).translate(-sinal * 0.022, 0, 0))
      pecas.push(new THREE.ConeGeometry(0.052, 0.022, 24, 1, true).rotateZ(sinal * Math.PI / 2).translate(-sinal * 0.027, 0, 0))
      disco(0.021, 0.018, -sinal * 0.032, 0, 0)
    }
    return unirDetalhes(pecas)
  }, [sinal, comprimento, altura, parte])
  return <MalhaDetalhe id={`${id}.${parte}`} criar={criar} nome={`detalhe-porta-${parte}`} />
}
